import styled from '@emotion/styled';
import { TabletWidth } from '../../../global.style';
import { getColor } from '../../common/UICommon';

export const BREAKPOINTS = {
  DESKTOP_MAX: 999999999,
  DESKTOP_MIN: TabletWidth,
  TABLET_BIG_MAX: TabletWidth,
  TABLET_BIG_MIN: 940,
  TABLET_SMALL_MAX: 940,
  TABLET_SMALL_MIN: 780,
  MOBILE_MAX: 780,
  MOBILE_MIN: 0,
};

// note that values of margins in @media corresponds with carouselResponsiveSettings values
export const InfoV2GuidesCarouselSliderWrapper = styled.div`
  background-color: ${getColor('BEIGE_5')};
  padding: 10% 0 4% 0;
  border-radius: 21px;
  transform: scale(0.8);
  transform-origin: center;
  margin-left: -10%;
  margin-right: -10%;

  @media (max-width: 1330px) {
    transform: scale(0.7);
    transform-origin: center;
    margin-left: -17%;
    margin-right: -17%;
  }

  @media (max-width: 1170px) {
    transform: scale(0.6);
    transform-origin: center;
    margin-left: -23%;
    margin-right: -33%;
  }

  @media (max-height: 350px) {
    transform: scale(0.65);
    transform-origin: center;
    margin-top: -30%;
  }

  @media (max-width: ${TabletWidth}px) {
    background-color: ${getColor('WHITE')};
    transform: scale(1);
    margin-left: -15%;
    margin-right: -15%;
    margin-top: -5%;
  }
  @media (max-width: 500px) {
    margin-left: -20%;
    margin-right: -20%;
    margin-top: -10%;
  }
  @media (max-width: 400px) {
    margin-left: -30%;
    margin-right: -30%;
    margin-top: -10%;
  }
  @media (max-width: 350px) {
    margin-left: -40%;
    margin-right: -40%;
    margin-top: -30%;
    transform: scale(0.65);
    transform-origin: center;
  }
`;

export const InfoV2GuidesCarouselSliderArrowsWrapper = styled.div`
  max-width: 1120px;
  margin: auto;
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 12px;

  @media (max-width: ${TabletWidth}px) {
    display: none;
  }
`;

export const InfoV2GuidesCarouselSliderArrow = styled.span`
  background-color: ${getColor('WHITE')};
  border: 2px solid ${getColor('OLD_GRAY_80')};
  border-radius: 100%;
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const InfoV2GuidesCarouselSliderArrowImg = styled.img``;
